/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface AdminFhirIdSpecialitiesGet$Params {
  fhirId: string;
}

export function adminFhirIdSpecialitiesGet(http: HttpClient, rootUrl: string, params: AdminFhirIdSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

adminFhirIdSpecialitiesGet.PATH = '/Admin/{fhirId}/Specialities';
